import React from "react";
import Modal from "react-bootstrap/Modal";

const formatAmount = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  const amount = Number(value);

  if (!Number.isFinite(amount)) return "—";

  return amount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatDateTime = (value) => {
  if (!value) return "—";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  })
    .format(date)
    .replace(/\b(am|pm)\b/g, (text) => text.toUpperCase());
};

const getName = (value) => value?.name || "—";

const PassbookDetailsModal = ({ passbook, handleClose }) => {
  const isActive = passbook?.status === "active";

  const details = passbook
    ? [
        ["Passbook ID", String(passbook._id || "—")],
        ["Passbook Name", passbook.name || "—"],
        ["CashMaker", getName(passbook.employee)],
        ["Email", passbook.employee?.email || "—"],
        ["Mobile", passbook.employee?.mobileNo || "—"],
        ["Store", getName(passbook.store)],
        ["Location", passbook.store?.location || "—"],
        ["Store Code", passbook.store?.storeCode || "—"],
        ["Remark", passbook.remark || "—"],
        ["Created By", getName(passbook.createdBy)],
        ["Created On", formatDateTime(passbook.createdAt)],
        ["Last Updated", formatDateTime(passbook.updatedAt)],
        ["Status Changed By", getName(passbook.statusChangedBy)],
        ["Status Changed On", formatDateTime(passbook.statusChangedAt)]
      ]
    : [];

  const totals = [
    {
      label: "Total In",
      value: passbook?.totalIn,
      color: "#198754",
      background: "#eef9f3"
    },
    {
      label: "Total Out",
      value: passbook?.totalOut,
      color: "#dc3545",
      background: "#fff1f2"
    },
    {
      label: "Balance",
      value: passbook?.balance,
      color: Number(passbook?.balance) < 0 ? "#dc3545" : "#1565c0",
      background: "#eef5ff"
    }
  ];

  return (
    <Modal
      show={Boolean(passbook)}
      onHide={handleClose}
      centered
      scrollable
      size="lg"
      aria-labelledby="passbook-details-title"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="passbook-details-title"
          style={{ fontSize: "20px" }}
        >
          Passbook Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {passbook && (
          <div
            style={{
              border: "1px solid #e5e9f0",
              borderRadius: "12px",
              padding: "20px",
              background: "#ffffff"
            }}
          >
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#343a40",
                  overflowWrap: "anywhere"
                }}
              >
                {passbook.name || "—"}
              </div>

              <span
                className={`badge ${
                  isActive ? "bg-success" : "bg-secondary"
                }`}
                style={{
                  fontSize: "11px",
                  padding: "6px 10px",
                  borderRadius: "20px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.15)"
                }}
              >
                {isActive ? "Active" : "Inactive"}
              </span>
            </div>

            <div className="row g-2 mb-3">
              {totals.map((total) => (
                <div key={total.label} className="col-12 col-sm-4">
                  <div
                    style={{
                      padding: "12px",
                      borderRadius: "8px",
                      background: total.background,
                      height: "100%"
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginBottom: "5px"
                      }}
                    >
                      {total.label}
                    </div>

                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: total.color,
                        overflowWrap: "anywhere"
                      }}
                    >
                      {formatAmount(total.value)}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              className="mb-2"
              style={{ fontSize: "13px", color: "#6c757d" }}
            >
              Passbook Information
            </div>

            <div className="table-responsive">
              <table
                className="table table-bordered mb-0"
                style={{ fontSize: "13px" }}
              >
                <tbody>
                  {details.map(([label, value]) => (
                    <tr key={label}>
                      <th
                        scope="row"
                        style={{
                          width: "38%",
                          minWidth: "140px",
                          background: "#f5f7fb",
                          color: "#495057",
                          fontWeight: 500,
                          padding: "11px 14px",
                          verticalAlign: "top"
                        }}
                      >
                        {label}
                      </th>

                      <td
                        style={{
                          padding: "11px 14px",
                          color: "#343a40",
                          overflowWrap: "anywhere",
                          whiteSpace: "pre-wrap",
                          verticalAlign: "top"
                        }}
                      >
                        {value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PassbookDetailsModal;